import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from "./Home";


import reportWebVitals from './reportWebVitals';
import AppRouter from "./AppRouter"; // not App

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
